<router-outlet></router-outlet>

<!-- Notificações Toast -->
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<!-- /Notificações Toast -->

<!-- Tours -->
<ngx-guided-tour [tourStepWidth]="360" [skipText]="'Pular'" [nextText]="'Próximo'" [doneText]="'Concluir'"
    [closeText]="'Fechar'" [backText]="'Voltar'"></ngx-guided-tour>
<!-- /Tours -->